import { FLEETPAGE } from '../actiontype'
import request from '@/utils/request'
import { fleetPageApi } from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetpageAction = (params) => {
    const action = (data) => (
        {
            type: FLEETPAGE,
            data
        }
    )
    return async (dispatch) => {
        let data = await request.post(fleetPageApi, {...params}, {
            ...inlineSign
        })
        if (data.data.data) {
            dispatch(action(data.data.data))
        }
    }
}